module.exports = __webpack_public_path__ + "img/home2.f291b195.svg";